import { useState, useEffect } from 'react'
import copyToClipboard from 'copy-to-clipboard'
import { noop } from 'lodash'

interface Options {
  // Reset the "copied" status in milliseconds
  resetDelay?: number
}

type IsCopied = boolean
type CopyFunction = () => void

export default function useCopyToClipboard(value: string, options?: Options): [IsCopied, CopyFunction] {
  const [isCopied, setIsCopied] = useState(false)
  const resetDelay = options && options.resetDelay

  useEffect(() => {
    if (isCopied && resetDelay) {
      const id = setTimeout(() => setIsCopied(false), resetDelay)

      return () => {
        clearTimeout(id)
      }
    }

    return noop
  }, [isCopied, resetDelay])

  function copy() {
    const copied = copyToClipboard(value)
    setIsCopied(copied)
  }

  return [isCopied, copy]
}
